import React from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { getWeekDay } from '@utils';

function DescriptionWeekDay(props) {

    const { date } = props;

    const descriptionWeekDay = () => {
        const weekDay = getWeekDay(date);

        let weekday = new Array(7);
        weekday[0] = `${i18next.t("scheduleAvailability:list.sundayAbbr")}`;
        weekday[1] = `${i18next.t("scheduleAvailability:list.mondayAbbr")}`;
        weekday[2] = `${i18next.t("scheduleAvailability:list.tuesdayAbbr")}`;
        weekday[3] = `${i18next.t("scheduleAvailability:list.wednesdayAbbr")}`;
        weekday[4] = `${i18next.t("scheduleAvailability:list.thursdayAbbr")}`;
        weekday[5] = `${i18next.t("scheduleAvailability:list.fridayAbbr")}`;
        weekday[6] = `${i18next.t("scheduleAvailability:list.saturdayAbbr")}`;

        return weekday[weekDay];
    }

    return (
        <span>{descriptionWeekDay()}</span>
    )
}

export default withNamespaces(['scheduleAvailability'], { wait: true })(DescriptionWeekDay);